export const getLogs = () => {
    return {
        type: 'GET_LOGS',
    };
};

export const setLogs = (logs) => {
    return {
        type: 'SET_LOGS',
        logs
    };
};

export const setSelectedLog = (log) => {
    return {
        type: 'SET_SELECTED_LOG',
        log
    };
};